import { Drawer, Dropdown } from "antd"
import { useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import { CheckSignInMethod } from "../newContent/api/api"
import SidebarV2 from "./SidebarV2"
import "../BorrowerApplication.css"
import "./styles.css"

const MobileHeaderV2 = ({
    application,
    activePartyId,
    activeSection,
    onAddCoborrower,
    onDeleteCoborrower,
    addingCoborrower,
    deletingCoborrowerPartyId,
}) => {
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [signInMethod, setSignInMethod] = useState("")

    const primary = useMemo(() => {
        const primaryPartyId = application?.primaryPartyId
        return primaryPartyId ? application?.participantsById?.[primaryPartyId] : null
    }, [application])

    useEffect(() => {
        setSidebarOpen(false)
    }, [activeSection, activePartyId])

    useEffect(() => {
        const email = primary?.email
        if (!email) {
            return
        }
        let isMounted = true
        CheckSignInMethod({
            CustomerID: sessionStorage.getItem("cid"),
            Email: email,
        })
            .then(({ Method }) => {
                if (isMounted) {
                    setSignInMethod(Method)
                }
            })
            .catch((error) => {
                console.error("Error fetching sign-in method:", error)
            })
        return () => {
            isMounted = false
        }
    }, [primary?.email])

    const dropdownItems = useMemo(() => [
        {
            label: (
                <Link
                    to={signInMethod === "email" ? "/application/password" : "/application/changepassword"}
                    className="DropdownP"
                >
                    {signInMethod === "email" ? "Set up password" : "Change password"}
                </Link>
            ),
            key: "password",
        },
        { type: "divider" },
        {
            label: (
                <Link to="/application/logout" className="DropdownP">
                    Sign out
                </Link>
            ),
            key: "logout",
        },
    ], [signInMethod])

    return (
        <>
            <header className="application-v2-mobile-topbar">
                <button
                    type="button"
                    className="application-v2-mobile-topbar-menu"
                    onClick={() => setSidebarOpen(true)}
                    aria-label="Open application menu"
                >
                    <img src="/images/topbar-menu.svg" alt="" />
                </button>
                <div className="application-v2-mobile-topbar-title">
                    {application?.companyName || ""}
                </div>
                <Dropdown overlayStyle={{ zIndex: 999999 }} menu={{ items: dropdownItems }}>
                    <div className="application-v2-mobile-topbar-avatar NameBar">
                        {(primary?.firstName || "B").charAt(0)}
                    </div>
                </Dropdown>
            </header>

            <Drawer
                placement="left"
                rootClassName="menu-drawer sidebar-drawer application-v2-sidebar-drawer"
                width="80%"
                closable={false}
                zIndex={1001}
                onClose={() => setSidebarOpen(false)}
                open={sidebarOpen}
            >
                <SidebarV2
                    variant="drawer"
                    application={application}
                    activePartyId={activePartyId}
                    activeSection={activeSection}
                    onAddCoborrower={onAddCoborrower}
                    onDeleteCoborrower={onDeleteCoborrower}
                    addingCoborrower={addingCoborrower}
                    deletingCoborrowerPartyId={deletingCoborrowerPartyId}
                    onNavigate={() => setSidebarOpen(false)}
                />
            </Drawer>
        </>
    )
}

export default MobileHeaderV2
